import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ErrorStateProps {
  message: string;
  onBack: () => void;
}

export const ErrorState: React.FC<ErrorStateProps> = ({ message, onBack }) => (
  <div className="w-full flex flex-col items-center justify-center py-24">
    <div className="flex justify-center mb-4">
      <div className="rounded-full bg-red-100 p-3">
        <AlertCircle className="w-8 h-8 text-red-600" />
      </div>
    </div>
    <h2 className="text-xl font-semibold text-gray-900 mb-2">Ops! Algo deu errado</h2>
    <p className="text-gray-600 mb-6">{message}</p>
    <Button onClick={onBack} variant="dark">
      Voltar para Reports
    </Button>
  </div>
);
